var image_viewer_rtlignore_default = {
  "fontElementMap": "-kQyX",
  "imageContainer": "VtQoB",
  "expandContainer": "_7eNg-",
  "expandIcon": "JiIhL",
  "pointer": "l9K-T",
  "imageWrapper": "ExHV1",
  "imageRatio": "irAtG",
  "image": "yhSBf",
  "imageOverlay": "RXBc2",
  "imagePreload": "RVESu",
  "imageHighres": "HQfbO",
  "onlyHighRes": "-b-80",
  "image_loading": "CV4FF"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
